import { jsxs as e, jsx as L } from "react/jsx-runtime";
const s = ({ size: i = 24, ...l }) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    ...l,
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#clip0_8048_2926)", children: [
        /* @__PURE__ */ L("mask", { id: "mask0_8048_2926", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ L("g", { mask: "url(#mask0_8048_2926)", children: /* @__PURE__ */ L("path", { d: "M24 24H0V11.9625L11.2969 11.2969L11.9625 0H24V24Z", fill: "#00008B" }) }),
        /* @__PURE__ */ L("mask", { id: "mask1_8048_2926", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ L("g", { mask: "url(#mask1_8048_2926)", children: /* @__PURE__ */ L("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0H12V12.0187H0V0Z", fill: "#00008B" }) }),
        /* @__PURE__ */ L("mask", { id: "mask2_8048_2926", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ L("g", { mask: "url(#mask2_8048_2926)", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M12 0.0234375L11.9766 0H10.7156L6.00937 4.70156L1.30781 0H0V1.32656L4.69219 6.01875L0 10.7156V12H1.35L6.00937 7.33594L10.6734 12H12V10.6922L7.32656 6.01875L12 1.35V0.0234375Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ L("mask", { id: "mask3_8048_2926", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ L("g", { mask: "url(#mask3_8048_2926)", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M11.5359 12H12V11.1234L6.69375 5.81719L12 0.50625V0H11.1609L5.80781 5.34844L0.459375 0H0V0.885937L5.33438 6.225L0 11.5594V12H0.890625L6.21563 6.675L11.5359 12Z",
            fill: "#FF0000"
          }
        ) }),
        /* @__PURE__ */ L("mask", { id: "mask4_8048_2926", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ L("g", { mask: "url(#mask4_8048_2926)", children: /* @__PURE__ */ L(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 4.57021H7.43906V0.00927734H4.56094V4.57021H0V7.44834H4.56094V12.0093H7.43906V7.44834H12V4.57021Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ L("mask", { id: "mask5_8048_2926", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ L("g", { mask: "url(#mask5_8048_2926)", children: /* @__PURE__ */ L(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 5.07647H6.93281V0.00927734H5.06719V5.07647H0V6.94209H5.06719V12.0093H6.93281V6.94209H12V5.07647Z",
            fill: "#FF0000"
          }
        ) }),
        /* @__PURE__ */ L("mask", { id: "mask6_8048_2926", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ L("g", { mask: "url(#mask6_8048_2926)", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M6.01874 14.1797L6.43593 15.4828L6.47343 15.5016L7.75311 15.0141L7.78593 15.0563L7.02655 16.1953L7.03593 16.2375L8.21249 16.9359L8.19843 16.9828L6.83905 17.1047L6.81093 17.1328L6.99843 18.4922L6.95155 18.5109L6.00936 17.5219H5.97186L5.02968 18.5109L4.9828 18.4922L5.1703 17.1328L5.14218 17.1047L3.77811 16.9828L3.76874 16.9359L4.9453 16.2375L4.95468 16.1953L4.1953 15.0563L4.22811 15.0141L5.5078 15.5016L5.5453 15.4828L5.96249 14.1797H6.01874ZM17.625 18.1875L18 17.625L17.9625 17.5781L17.3297 17.8172L17.2875 17.7984L17.0812 17.1562H17.0203L16.8141 17.7984L16.7719 17.8172L16.1391 17.5781L16.1016 17.625L16.4766 18.1875L16.4672 18.2297L15.8859 18.5766C15.8578 18.5906 15.8672 18.6328 15.9 18.6328L16.575 18.6891L16.6031 18.7266L16.5094 19.3969C16.5047 19.425 16.5422 19.4437 16.5609 19.4203L17.025 18.9328H17.0719L17.5359 19.4203C17.5547 19.4437 17.5922 19.425 17.5875 19.3969L17.4937 18.7266L17.5219 18.6891L18.1922 18.6328C18.2203 18.6281 18.2297 18.5906 18.2062 18.5766L17.625 18.2297V18.1875ZM15.2484 11.1047L15.6234 10.5422L15.5859 10.4953L14.9531 10.7344L14.9109 10.7156L14.7047 10.0734H14.6437L14.4375 10.7156L14.3953 10.7344L13.7625 10.4953L13.725 10.5422L14.1 11.1047L14.0906 11.1469L13.5094 11.4937C13.4812 11.5078 13.4906 11.55 13.5234 11.55L14.1984 11.6063L14.2266 11.6437L14.1328 12.3141C14.1281 12.3422 14.1656 12.3609 14.1844 12.3375L14.6484 11.85H14.6953L15.1594 12.3375C15.1781 12.3609 15.2156 12.3422 15.2109 12.3141L15.1172 11.6437L15.1453 11.6063L15.8156 11.55C15.8437 11.5453 15.8531 11.5078 15.8297 11.4937L15.2484 11.1469V11.1047ZM16.6078 6.79688L16.5141 7.46719C16.5094 7.49531 16.5469 7.51406 16.5656 7.49063L17.0297 7.00312H17.0766L17.5406 7.49063C17.5594 7.51406 17.5969 7.49531 17.5922 7.46719L17.4984 6.79688L17.5266 6.75937L18.1969 6.70312C18.225 6.69844 18.2344 6.66094 18.2109 6.64688L17.6297 6.3L17.6203 6.25781L17.9953 5.69531L17.9578 5.64844L17.325 5.8875L17.2828 5.86875L17.0766 5.22656H17.0156L16.8094 5.86875L16.7672 5.8875L16.1344 5.64844L16.0969 5.69531L16.4719 6.25781L16.4625 6.3L15.8812 6.64688C15.8531 6.66094 15.8625 6.70312 15.8953 6.70312L16.5703 6.75937L16.6078 6.79688ZM22.1953 10.2984L21.6141 9.95156L21.6047 9.90937L21.9797 9.34687L21.9422 9.3L21.3094 9.53906L21.2672 9.52031L21.0609 8.87812H21L20.7937 9.52031L20.7516 9.53906L20.1187 9.3L20.0812 9.34687L20.4562 9.90937L20.4469 9.95156L19.8656 10.2984C19.8375 10.3125 19.8469 10.3547 19.8797 10.3547L20.5547 10.4109L20.5828 10.4484L20.4891 11.1187C20.4844 11.1469 20.5219 11.1656 20.5406 11.1422L21.0047 10.6547H21.0516L21.5156 11.1422C21.5344 11.1656 21.5719 11.1469 21.5672 11.1187L21.4734 10.4484L21.5016 10.4109L22.1766 10.3547C22.2094 10.3547 22.2187 10.3125 22.1953 10.2984ZM19.0312 12.8344L18.8719 12.4453H18.8156L18.6562 12.8344L18.6281 12.8531L18.2109 12.8859L18.1922 12.9375L18.5156 13.2094L18.525 13.2422L18.4219 13.65L18.4687 13.6828L18.8297 13.4625H18.8625L19.2187 13.6828L19.2656 13.65L19.1625 13.2422L19.1719 13.2094L19.4953 12.9375L19.4766 12.8859L19.0594 12.8531L19.0312 12.8344Z",
            fill: "white"
          }
        ) })
      ] }),
      /* @__PURE__ */ L("defs", { children: /* @__PURE__ */ L("clipPath", { id: "clip0_8048_2926", children: /* @__PURE__ */ L("rect", { width: "24", height: "24", rx: "12", fill: "white" }) }) })
    ]
  }
);
export {
  s as RegionAPACIcon
};
